// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-menu {
    background-color: var(--main-bg-color);
}

.trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
}

.login-user-row {
  text-align: center;
  padding-top: 20px;
  height: 65px;
  font-size: 14px;
  letter-spacing: normal;
  color: white;
  display: flex;
  flex-direction: column;
}

.ant-menu-item .dashboard-icons:hover{
  color: #be67bd;
}

.back-top {
  height: 80px;
  width: 80px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #96d9f8;
  text-align: center;
  font-size: 40px;
}

.logo {
  display: block;
  width: 65%;
  margin-inline: auto;
  cursor: pointer;
}

.mobile-header {
  padding-top: 16px;
  background: var(--main-bg-color);
}

.logo-mobile {
  height: 80px;
  margin: 24px;
  cursor: pointer;
  margin: auto;
  display:block;
}

.logo-square {
  height: 48px;
  cursor: pointer;
}

.logo-square-1 {
  height: 48px;
  margin: 24px;
  cursor: pointer;
}

.sider {
  background: var(--main-bg-color) !important;
}

.empty-white {
  height:100%;
  background: var(--main-bg-color) !important;
}

.side-menu-border {
  border: none !important;
}

.bm-burger-button {
  position:fixed;
}

.unselectable {
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* IE10+/Edge */
  user-select: none; /* Standard */
}

.scrollbar {
	float: left;
	height: 300px;
	overflow-y: auto;
}

.scrollbar::-webkit-scrollbar {
	width: 5px;
	background-color: #F5F5F5;
}

.scrollbar::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(179, 179, 179, 0.3);
	background-color: #F5F5F5;
}

.scrollbar::-webkit-scrollbar-thumb {
	background-color: #aaaaaa;
	border: 2px solid #aaaaaa;
}

.table-row-selected {
  background-color: #ADD8E6;
}

.ant-menu-item-group-title {
  padding: 0 0 !important;
}

.ant-layout-sider {
  transition: all 0.3s ease;
}


.ant-menu-inline .ant-menu-item::after {
  border-right: none;
}

.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
  border-right: none !important;
}

.ant-menu-item .anticon, .ant-menu-submenu-title .anticon {
  font-size: 24px !important;
  min-width: 22px !important;
  opacity: 0.9 !important;
  margin-right: 0 !important;
}

.footer-sidebar {
  position: fixed;
  bottom: 0;
  width: 200px;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-sidebar-height-minimized {
  height: 100px;
}

.footer-sidebar-height-maximized {
  height: 200px;
}

.side-menu-height-collapsed {
  height: calc( 100% - 100px - 70px ); /* 70px for header, 100px for footer */
}

.side-menu-height-expanded {
  height: calc( 100% - 200px - 70px ); /* 70px for header, 200px for footer */
}

.side-menu-overflow {
  overflow-y: auto;
  overflow-x: hidden;
}

.side-menu-overflow::-webkit-scrollbar {
  display: none;
}

.links-btn .anticon {
  font-size: 24px;
  min-width: 22px;
  opacity: 0.9;
}

.links-btn {
  display: block;
  padding: 10px;
  text-decoration: none;
  color: #fff;
}

.user-menu {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
}

.user-btn {
  color: #fff;
  border: none;
  cursor: pointer;
}

.user-name {
  font-size: 15px;
  font-weight: bold;
  margin-left: 15px;
  margin-right: 15px;
}

.user-info {
  background-color: #3A2244;
  padding: 10px;
  transition: all 0.2s ease;
}

.user-info .links-btn:hover {
  color: #be67bd;
}

.expand-icon {
  color: #fff;
  opacity: 0.4;
  font-weight: bold;
}

.thin-scrollbar::-webkit-scrollbar {
  width: 5px;
  position: absolute;
  left: -50px;
}

.thin-scrollbar::-webkit-scrollbar-thumb {
  background-color: darkgray;
}
.thin-scrollbar::-webkit-scrollbar-track {
  background: lightgray;
  border-radius: 5px;
}

.antd-to-mui-styling button {
  background-color: rgb(112,11,128);
  border-color: rgb(112,11,128);
}

.antd-to-mui-styling button:hover {
  background-color: rgb(147, 15, 170);
  border-color: rgb(147, 15, 170);
}

.success-network-status .ant-alert-with-description .ant-alert-close-icon {
  top: 7px !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/morpheus.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe;EACrE,iBAAiB,EAAE,aAAa;AAClC;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,0DAA0D;CAC1D,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC,EAAE,sCAAsC;AAC7E;;AAEA;EACE,mCAAmC,EAAE,sCAAsC;AAC7E;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".dashboard-menu {\n    background-color: var(--main-bg-color);\n}\n\n.trigger {\n    font-size: 18px;\n    line-height: 64px;\n    padding: 0 24px;\n    cursor: pointer;\n    transition: color 0.3s;\n}\n\n.login-user-row {\n  text-align: center;\n  padding-top: 20px;\n  height: 65px;\n  font-size: 14px;\n  letter-spacing: normal;\n  color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.ant-menu-item .dashboard-icons:hover{\n  color: #be67bd;\n}\n\n.back-top {\n  height: 80px;\n  width: 80px;\n  line-height: 40px;\n  border-radius: 4px;\n  background-color: #96d9f8;\n  text-align: center;\n  font-size: 40px;\n}\n\n.logo {\n  display: block;\n  width: 65%;\n  margin-inline: auto;\n  cursor: pointer;\n}\n\n.mobile-header {\n  padding-top: 16px;\n  background: var(--main-bg-color);\n}\n\n.logo-mobile {\n  height: 80px;\n  margin: 24px;\n  cursor: pointer;\n  margin: auto;\n  display:block;\n}\n\n.logo-square {\n  height: 48px;\n  cursor: pointer;\n}\n\n.logo-square-1 {\n  height: 48px;\n  margin: 24px;\n  cursor: pointer;\n}\n\n.sider {\n  background: var(--main-bg-color) !important;\n}\n\n.empty-white {\n  height:100%;\n  background: var(--main-bg-color) !important;\n}\n\n.side-menu-border {\n  border: none !important;\n}\n\n.bm-burger-button {\n  position:fixed;\n}\n\n.unselectable {\n  -webkit-user-select: none; /* Safari */ /* Firefox */ /* IE10+/Edge */\n  user-select: none; /* Standard */\n}\n\n.scrollbar {\n\tfloat: left;\n\theight: 300px;\n\toverflow-y: auto;\n}\n\n.scrollbar::-webkit-scrollbar {\n\twidth: 5px;\n\tbackground-color: #F5F5F5;\n}\n\n.scrollbar::-webkit-scrollbar-track {\n\t-webkit-box-shadow: inset 0 0 6px rgba(179, 179, 179, 0.3);\n\tbackground-color: #F5F5F5;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n\tbackground-color: #aaaaaa;\n\tborder: 2px solid #aaaaaa;\n}\n\n.table-row-selected {\n  background-color: #ADD8E6;\n}\n\n.ant-menu-item-group-title {\n  padding: 0 0 !important;\n}\n\n.ant-layout-sider {\n  transition: all 0.3s ease;\n}\n\n\n.ant-menu-inline .ant-menu-item::after {\n  border-right: none;\n}\n\n.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {\n  border-right: none !important;\n}\n\n.ant-menu-item .anticon, .ant-menu-submenu-title .anticon {\n  font-size: 24px !important;\n  min-width: 22px !important;\n  opacity: 0.9 !important;\n  margin-right: 0 !important;\n}\n\n.footer-sidebar {\n  position: fixed;\n  bottom: 0;\n  width: 200px;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.footer-sidebar-height-minimized {\n  height: 100px;\n}\n\n.footer-sidebar-height-maximized {\n  height: 200px;\n}\n\n.side-menu-height-collapsed {\n  height: calc( 100% - 100px - 70px ); /* 70px for header, 100px for footer */\n}\n\n.side-menu-height-expanded {\n  height: calc( 100% - 200px - 70px ); /* 70px for header, 200px for footer */\n}\n\n.side-menu-overflow {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.side-menu-overflow::-webkit-scrollbar {\n  display: none;\n}\n\n.links-btn .anticon {\n  font-size: 24px;\n  min-width: 22px;\n  opacity: 0.9;\n}\n\n.links-btn {\n  display: block;\n  padding: 10px;\n  text-decoration: none;\n  color: #fff;\n}\n\n.user-menu {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n.user-btn {\n  color: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.user-name {\n  font-size: 15px;\n  font-weight: bold;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.user-info {\n  background-color: #3A2244;\n  padding: 10px;\n  transition: all 0.2s ease;\n}\n\n.user-info .links-btn:hover {\n  color: #be67bd;\n}\n\n.expand-icon {\n  color: #fff;\n  opacity: 0.4;\n  font-weight: bold;\n}\n\n.thin-scrollbar::-webkit-scrollbar {\n  width: 5px;\n  position: absolute;\n  left: -50px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb {\n  background-color: darkgray;\n}\n.thin-scrollbar::-webkit-scrollbar-track {\n  background: lightgray;\n  border-radius: 5px;\n}\n\n.antd-to-mui-styling button {\n  background-color: rgb(112,11,128);\n  border-color: rgb(112,11,128);\n}\n\n.antd-to-mui-styling button:hover {\n  background-color: rgb(147, 15, 170);\n  border-color: rgb(147, 15, 170);\n}\n\n.success-network-status .ant-alert-with-description .ant-alert-close-icon {\n  top: 7px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
